import React from "react";
import PropTypes from "prop-types";

import TableHead from "@material-ui/core/TableHead";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import TableRow from "@material-ui/core/TableRow";

export default function TableHeader(props) {
  const { order, orderBy, onRequestSort, headCells, sizeHead = "10px" } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const style = (headCell) => {
    return {
      fontSize: "12px",
      minWidth: headCell.minWidth !== null ? headCell.minWidth : "200px",
      width: headCell.width ?? "auto",
      padding: sizeHead,
      textAlign: headCell.align,
    };
  };

  return (
    <TableHead>
      <TableRow
        style={{
          backgroundColor: "#fff",
        }}>
        {headCells.map((headCell) => (
          <td key={headCell.id} style={style(headCell)}>
            {headCell.sort === false ? (
              headCell.label
            ) : (
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}>
                {headCell.label}
              </TableSortLabel>
            )}
          </td>
        ))}
      </TableRow>
    </TableHead>
  );
}

TableHeader.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  // rowCount: PropTypes.number.isRequired,
};
